import Date from '../date/Date';
import MembershipNumber from './MembershipNumber';
import ParameterValue from './ParameterValue';

export default class MemberRegularContract {
    constructor() {
        this.id = null;
        this.memberId = null;
        this.type = 'regular';
        this.membershipNumber = new MembershipNumber();
        this.start = null;
        this.end = null;
        this.terminationReason = null;
        this.deleted = false;
        this.invalidChanges = [];
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        let memberContract = new MemberRegularContract();
        memberContract.id = data.id;
        memberContract.membershipNumber = MembershipNumber.fromData(data.membershipNumber);
        memberContract.start = data.start !== null ? Date.fromIso8601(data.start) : null;
        memberContract.end = data.end !== null ? Date.fromIso8601(data.end) : null;
        memberContract.memberId = data.memberId;
        memberContract.invalidChanges = [];

        memberContract.terminationReason = null;
        if (data.terminationReason && data.terminationReason.data) {
            memberContract.terminationReason = ParameterValue.fromData(data.terminationReason.data);
        }

        return memberContract;
    }

    isNew() {
        return this.id === null;
    }

    isActive() {
        let today = Date.today();
        return this.start !== null && this.start.isBeforeOrEqual(today) && (this.end === null || this.end.isAfterOrEqual(today));
    }

    serialize() {
        return {
            id: this.id,
            memberId: this.memberId,
            type: 'regular',
            membershipNumber: null !== this.membershipNumber.counter ? this.membershipNumber : null,
            start: this.start !== null ? this.start.toIso8601() : null,
            end: this.end !== null ? this.end.toIso8601() : null,
            terminationReasonId: null === this.terminationReason ? null : this.terminationReason.id
        };


    }
}
